import { type FC, type PropsWithChildren } from 'react';

import styles from './styles.css';

export const MortgageOffersTable: FC<PropsWithChildren<{}>> = ({ children }) => (
  <div className={styles['container']} data-testid="MortgageOffersTable">
    {children}
  </div>
);
